<template>
    <info-header-card :header="header" :rows="rows"></info-header-card>
</template>
<script>
import InfoHeaderCard from "@/components/shared/InfoHeaderCard";
import moment from 'moment';
import { formatModelPath, stripTaskFromName } from "@/shared/utils";

export default {
    name: "QualityControlCard",
    components: { 
        InfoHeaderCard,
    },
    props: {
        qualityControl: {
            type: Object,
            required: true
        }
    },
    computed: {
        header() {
            return this.qualityControl.name;
        },
        rows() {
            return [
                {
                    label: "Name",
                    value: this.qualityControl.name
                },
                {
                    label: "Sheet Label",
                    value: this.qualityControl.sheet_label
                },
                {
                    label: "Description",
                    value: this.qualityControl.description
                },
                {
                    label: "Interval",
                    value: this.qualityControl.interval
                },
                {
                    label: "Interval Index",
                    value: this.qualityControl.interval_index
                },
                {
                    label: "Task Type",
                    value: stripTaskFromName(formatModelPath(this.qualityControl.schedulable_task_type))
                },
                {
                    label: "Scheduable Task",
                    value: this.qualityControl.schedulable_task.name
                },
                {
                    label: "Created On",
                    value: moment(this.qualityControl.created_at).format('YYYY-MM-DD')
                }
            ];
        },
    },
};
</script>